import styled, { css } from 'styled-components'

import {
    FlexCentered,
    FullWidthHeight,
    AbsolutePositioning,
} from 'components/common/genericStyles'

export const AvatarWrapper = styled.div`
    width: 12vw;
    height: 12vw;
`

export const Container = styled.div`
    ${FullWidthHeight}
    background: rgba(0, 0, 8, 0.5);
    border-radius: 16px;
    ${FlexCentered}
    flex-direction: column;

    ${AbsolutePositioning}

    & > span {
        margin-top: 20px;
        font-size: 1.3rem;
        text-align: center;
    }

    ${props =>
        props.isArtefactMode &&
        css`
            ${AvatarWrapper} {
                width: 9vw;
                height: 9vw;
            }

            & > span {
                margin-top: 15px;
                font-size: 1rem;
            }
        `}
`
